/* ==========================================================================
   Foot Cardigan, gift-first subscription PDP (v2)

   One handler, one source of truth. The legacy flow bound BOTH a jQuery
   `submit` handler (assets/subscription.js) and an inline `click` handler that
   called preventDefault(), so the submit handler never ran and gift validation
   was dead code. Everything here lives in a single click handler.

   Line-item property names are read by Goldie and MUST NOT change:
     Gift Recipient Name · Gift Recipient Email · Gift Message
     Date to Email Gift Message · Shipping Date
   Dates are "F j, Y" (e.g. "December 25, 2026"); Goldie parses that format.
   ========================================================================== */
/* Several sections each reference this file, and a browser executes every
   <script src> tag it meets, so without this guard the whole module ran once
   per section (five IntersectionObservers, five confetti listeners, five
   buy-box bindings). Run once per page. */
if (!window.__fcv2Init) {
  window.__fcv2Init = true;

  (function () {
    'use strict';

    var root = document.querySelector('[data-fcv2-buybox]');
    if (!root) return;

    var dataEl = document.getElementById('fcv2-data');
    if (!dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!DATA.plans || !DATA.plans.length) return;

    var MONEY_FMT = DATA.moneyFormat || '${{amount}}';
    var PLANS = {};
    DATA.plans.forEach(function (p) { PLANS[p.key] = p; });

    // prepaid plans, longest first, gifts are prepaid only
    var GIFT_ORDER = ['m12', 'm9', 'm6'].filter(function (k) { return PLANS[k]; });
    var SELF_ORDER = ['monthly', 'm6', 'm9', 'm12'].filter(function (k) { return PLANS[k]; });

    var MSGS = [
      'Your sock drawer called. It’s bored. I fixed it.',
      'Some people get a tie. You get a year of socks that start conversations.',
      'Step 1: open box. Step 2: put on socks. Step 3: become the most interesting person in the room.',
      'I couldn’t pick one pair, so I picked a whole year of them.',
      'Merry Christmas. Your feet are about to peak.'
    ];

    var s = {
      who: 'gift',
      plan: GIFT_ORDER[0] || SELF_ORDER[0],
      size: (DATA.sizes[0] || {}).value,
      pairs: (DATA.pairs[0] || {}).value,
      msg: MSGS[0],
      from: '',
      name: '',
      email: '',
      emailDate: '',
      shipDate: '',
      giftOpen: null // gift details collapsed on mobile, open on desktop; persists across re-renders
    };

    /* ----------------------------- helpers ----------------------------- */
    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      return MONEY_FMT.replace(/\{\{\s*amount\s*\}\}/, amount)
                      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
    }
    function esc(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim()); }

    function variantOf(planKey, size, pairs) {
      var p = PLANS[planKey];
      if (!p) return null;
      return p.variants[size + '|' + pairs] || null;
    }
    // price per month, so the ladder is legible and 12 months reads as better value
    function perMonth(planKey) {
      var p = PLANS[planKey], v = variantOf(planKey, s.size, s.pairs);
      if (!p || !v) return null;
      return p.months ? Math.round(v.price / p.months) : v.price;
    }
    // what the same term would cost paying monthly, the only honest comparison.
    // Never a struck-through "was" price (bfcm-brief.md §11, FTC 16 CFR 233.1).
    function monthlyEquivalent(planKey) {
      var p = PLANS[planKey], m = PLANS.monthly;
      if (!p || !p.months || !m) return null;
      var mv = variantOf('monthly', s.size, s.pairs);
      return mv ? mv.price * p.months : null;
    }

    /* ----------------------------- markup ----------------------------- */
    function optBtn(k, v, title, sub, badge, disabled) {
      var on = String(s[k]) === String(v);
      return '<button type="button" class="opt" data-k="' + k + '" data-v="' + esc(v) + '"' +
        ' aria-pressed="' + on + '"' + (disabled ? ' disabled' : '') + '>' +
        (badge ? '<span class="badge">' + esc(badge) + '</span>' : '') +
        '<b>' + esc(title) + '</b>' + (sub ? '<span>' + esc(sub) + '</span>' : '') +
        '</button>';
    }
    function field(id, prop, label, placeholder, value, kind) {
      var input = kind === 'area'
        ? '<textarea id="' + id + '" rows="3" data-prop="' + esc(prop) + '" placeholder="' + esc(placeholder) + '">' + esc(value) + '</textarea>'
        : '<input id="' + id + '"' + (kind === 'email' ? ' type="email"' : ' type="text"') +
          (kind === 'date' ? ' readonly' : '') +
          ' value="' + esc(value) + '" placeholder="' + esc(placeholder) + '" autocomplete="off" data-prop="' + esc(prop) + '">';
      return '<div class="fld' + (kind === 'area' || kind === 'full' ? ' full' : '') + '" data-f="' + id + '">' +
        '<label for="' + id + '">' + esc(label) + '</label>' + input +
        '<p class="err" id="' + id + '-err" role="alert"></p></div>';
    }

    function planList() {
      var keys = s.who === 'gift' ? GIFT_ORDER : SELF_ORDER;
      return keys.map(function (k) {
        var p = PLANS[k], pm = perMonth(k), eq = monthlyEquivalent(k), v = variantOf(k, s.size, s.pairs);
        var sub, badge = '';
        if (k === 'monthly') {
          sub = (pm != null ? money(pm) : '') + '/mo · cancel anytime';
        } else {
          sub = (pm != null ? money(pm) : '') + '/mo · one charge';
          if (eq && v && v.price < eq) {
            var saved = eq - v.price;
            var freeMonths = PLANS.monthly && variantOf('monthly', s.size, s.pairs)
              ? Math.round(saved / variantOf('monthly', s.size, s.pairs).price) : 0;
            if (freeMonths === 1) badge = '1 month free';
            else if (freeMonths > 1) badge = freeMonths + ' months free';
            else badge = 'best value';
          }
        }
        return { key: k, title: p.title, sub: sub, badge: badge, available: !!v };
      });
    }

    function render() {
      destroyPickers();
      if (s.who === 'gift' && s.plan === 'monthly') s.plan = GIFT_ORDER[0];
      var pl = planList();
      if (!PLANS[s.plan]) s.plan = pl[0] && pl[0].key;

      var v = variantOf(s.plan, s.size, s.pairs);
      var isMonthly = s.plan === 'monthly';
      var priceLabel = v ? (isMonthly ? money(v.price) + '/mo' : money(v.price)) : '';

      var note = isMonthly
        ? 'renews monthly at ' + money((variantOf('monthly', s.size, s.pairs) || {}).price || 0) + '. pause, skip or cancel anytime.'
        : 'prepaid. one charge. never auto-renews.';

      var eq = monthlyEquivalent(s.plan), freeLine = '';
      if (!isMonthly && v && eq && v.price < eq) {
        freeLine = '<p class="fine free">that’s ' + money(eq - v.price) + ' off' +
          money(v.price) + ' instead of ' + money(eq) + ' paying monthly.</p>';
      }

      var segClass = pl.length === 4 ? 'c2' : 'c' + pl.length;

      // gift details: open by default on desktop, collapsed on mobile; choice persists
      if (s.giftOpen === null) s.giftOpen = window.matchMedia('(min-width: 981px)').matches;

      root.innerHTML =
        '<div class="row"><span class="eyebrow">' +
          (s.who === 'gift' ? 'who’s the lucky person?' : 'let’s set you up') +
        '</span><span class="rating">est. 2012</span></div>' +

        '<div class="seg c2" role="group" aria-label="Who is it for">' +
          optBtn('who', 'gift', 'gift the fun', 'they get a surprise every month') +
          optBtn('who', 'self', 'treat yourself', 'your mailbox, your socks') +
        '</div>' +

        '<div class="lbl" id="fcv2-plan-lbl">how long should the fun last?</div>' +
        '<div class="seg ' + segClass + '" role="group" aria-labelledby="fcv2-plan-lbl">' +
          pl.map(function (x) { return optBtn('plan', x.key, x.title, x.sub, x.badge, !x.available); }).join('') +
        '</div>' +
        '<p class="fine ' + (isMonthly ? '' : 'ok') + '">' + note + '</p>' + freeLine +

        '<div class="lbl" id="fcv2-size-lbl">what size?</div>' +
        '<div class="seg c2" role="group" aria-labelledby="fcv2-size-lbl">' +
          DATA.sizes.map(function (o) { return optBtn('size', o.value, o.title, o.sub); }).join('') +
        '</div>' +

        '<div class="lbl" id="fcv2-pairs-lbl">how many pairs a month?</div>' +
        '<div class="seg c2" role="group" aria-labelledby="fcv2-pairs-lbl">' +
          DATA.pairs.map(function (o) { return optBtn('pairs', o.value, o.title, o.sub); }).join('') +
        '</div>' +

        (s.who === 'gift'
          ? '<details class="gform" data-gform' + (s.giftOpen ? ' open' : '') + '>' +
              '<summary class="gsum"><span class="gsum-t">the surprise</span>' +
              '<span class="gsum-sub">their details + a note</span>' +
              '<i class="gsum-x" aria-hidden="true"></i></summary>' +
            '<div class="f">' +
              field('fcv2-name',  'Gift Recipient Name',        'their first name', 'Dad', s.name, 'text') +
              field('fcv2-email', 'Gift Recipient Email',       'their email', 'dad@example.com', s.email, 'email') +
              field('fcv2-edate', 'Date to Email Gift Message', 'email the surprise on', 'pick a date', s.emailDate, 'date') +
              (isMonthly ? '' : field('fcv2-sdate', 'Shipping Date', 'ship the first pair', 'pick a date', s.shipDate, 'date')) +
              field('fcv2-msg',   'Gift Message',               'your message', 'say something ridiculous', s.msg, 'area') +
              field('fcv2-from',  '',                            'from (so they know who to thank)', 'Dad', s.from, 'full') +
            '</div>' +
            '<div class="msgrow"><p class="hint">we email them that morning, not before. no prices in the box.</p>' +
            '<button type="button" class="gen" data-gen>✨ write it for me</button></div></details>'
          : '') +

        '<p class="formerr" id="fcv2-formerr" role="alert"></p>' +

        '<button class="cta" type="button" data-add>' +
          (s.who === 'gift' ? 'gift it' : 'start my socks') +
          ' <span class="p">· ' + priceLabel + '</span>' +
        '</button>' +

        '<div class="trust"><span>30-day money back</span><span>free shipping, always</span><span>' +
          (s.who === 'gift' ? 'no price in the box' : 'pause or skip anytime') + '</span></div>';

      bind();
      initPickers();
      syncSticky(priceLabel);
    }

    /* ----------------------------- binding ----------------------------- */
    function bind() {
      root.querySelectorAll('.opt').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.hasAttribute('disabled')) return;
          s[b.dataset.k] = b.dataset.v;
          render();
        });
      });

      var map = {
        'fcv2-name': 'name', 'fcv2-email': 'email', 'fcv2-edate': 'emailDate',
        'fcv2-sdate': 'shipDate', 'fcv2-msg': 'msg', 'fcv2-from': 'from'
      };
      Object.keys(map).forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        el.addEventListener('input', function () {
          s[map[id]] = el.value;
          clearError(id);
        });
        el.addEventListener('change', function () { s[map[id]] = el.value; });
      });

      var gen = root.querySelector('[data-gen]');
      var msgEl = document.getElementById('fcv2-msg');
      if (gen && msgEl) {
        gen.addEventListener('click', function () {
          var i = MSGS.indexOf(s.msg);
          s.msg = MSGS[(i + 1 + MSGS.length) % MSGS.length];
          msgEl.value = s.msg;
          msgEl.style.background = '#FFF7DC';
          setTimeout(function () { msgEl.style.background = '#fff'; }, 400);
        });
      }

      var gform = root.querySelector('[data-gform]');
      if (gform) gform.addEventListener('toggle', function () { s.giftOpen = gform.open; });

      var add = root.querySelector('[data-add]');
      if (add) add.addEventListener('click', addToCart);
    }

    /* ----------------------------- date pickers ----------------------------- */
    // render() replaces the buy box markup on every choice, so old flatpickr
    // instances must be torn down or their calendar nodes pile up on <body>.
    var pickers = [];
    function destroyPickers() {
      pickers.forEach(function (p) { try { p.destroy(); } catch (e) {} });
      pickers = [];
    }
    // 60-day window confirmed with ops. Format must stay "F j, Y" for Goldie.
    function initPickers() {
      if (typeof window.flatpickr !== 'function') return;
      function plus(days) { var d = new Date(); d.setDate(d.getDate() + days); return d; }
      var WINDOW = {
        'fcv2-edate': plus(DATA.emailWindowDays || DATA.giftWindowDays || 180),
        'fcv2-sdate': plus(DATA.shipWindowDays || DATA.giftWindowDays || 60)
      };
      ['fcv2-edate', 'fcv2-sdate'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || el._flatpickr) return;
        pickers.push(window.flatpickr(el, {
          dateFormat: 'F j, Y',
          minDate: 'today',
          maxDate: WINDOW[id],
          disableMobile: true,
          onChange: function (sel, str) {
            s[id === 'fcv2-edate' ? 'emailDate' : 'shipDate'] = str;
            clearError(id);
          }
        }));
      });
    }

    /* ----------------------------- validation ----------------------------- */
    function setError(id, msg) {
      var fld = root.querySelector('[data-f="' + id + '"]');
      if (!fld) return;
      fld.classList.add('is-error');
      fld.classList.remove('is-valid');
      var err = document.getElementById(id + '-err');
      if (err) err.textContent = msg;
    }
    function clearError(id) {
      var fld = root.querySelector('[data-f="' + id + '"]');
      if (fld) fld.classList.remove('is-error');
    }
    function validate() {
      var bad = [];
      if (s.who !== 'gift') return bad;

      if (!String(s.name).trim()) { setError('fcv2-name', 'Who’s it for? Add their first name.'); bad.push('fcv2-name'); }
      if (!String(s.email).trim()) { setError('fcv2-email', 'We need their email to send the surprise.'); bad.push('fcv2-email'); }
      else if (!isEmail(s.email)) { setError('fcv2-email', 'That doesn’t look like a valid email.'); bad.push('fcv2-email'); }
      if (!String(s.emailDate).trim()) { setError('fcv2-edate', 'Pick the morning they should find out.'); bad.push('fcv2-edate'); }
      return bad;
    }

    /* ----------------------------- add to cart ----------------------------- */
    function giftProperties() {
      var props = {};
      if (s.who !== 'gift') return props;
      // Exact keys Goldie parses, do not rename.
      props['Gift Recipient Name'] = String(s.name).trim();
      props['Gift Recipient Email'] = String(s.email).trim();
      props['Date to Email Gift Message'] = String(s.emailDate).trim();
      if (String(s.shipDate).trim()) props['Shipping Date'] = String(s.shipDate).trim();

      // The old flow baked "[your name]" into the canned message and nobody
      // replaced it. The sign-off is its own field now and is appended here.
      var msg = String(s.msg).trim();
      var from = String(s.from).trim();
      if (from) msg = msg ? msg + '\n' + from : '' + from;
      if (msg) props['Gift Message'] = msg;
      return props;
    }

    function billingAnchors() {
      // Monthly renews on the 1st; orders on/after the 25th skip to the month after.
      var now = new Date(), day = now.getDate();
      var next = day >= 25
        ? new Date(now.getFullYear(), now.getMonth() + 2, 1)
        : new Date(now.getFullYear(), now.getMonth() + 1, 1);
      return {
        '_next_billing_date': next.toISOString().replace(/\.\d+Z$/, 'Z'),
        '_order-date': now.toISOString().replace(/\.\d+Z$/, 'Z')
      };
    }

    function addToCart() {
      var formErr = document.getElementById('fcv2-formerr');
      if (formErr) { formErr.classList.remove('on'); formErr.textContent = ''; }

      var bad = validate();
      if (bad.length) {
        // the missing fields may be inside the collapsed gift details, open it first
        var gform = root.querySelector('[data-gform]');
        if (gform && !gform.open) { s.giftOpen = true; gform.open = true; }
        if (formErr) {
          formErr.textContent = 'Just a couple of things missing before we can send this.';
          formErr.classList.add('on');
        }
        var first = document.getElementById(bad[0]);
        if (first) { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }

      var variant = variantOf(s.plan, s.size, s.pairs);
      if (!variant) {
        if (formErr) {
          formErr.textContent = 'That combination isn’t available right now. Try another size or plan.';
          formErr.classList.add('on');
        }
        return;
      }

      var plan = PLANS[s.plan];
      var props = giftProperties();
      if (plan.sellingPlan) props['__appstle-selected-selling-plan'] = String(plan.sellingPlan);
      if (s.plan === 'monthly') {
        var anchors = billingAnchors();
        Object.keys(anchors).forEach(function (k) { props[k] = anchors[k]; });
      }

      var item = { id: variant.id, quantity: 1 };
      if (plan.sellingPlan) item.selling_plan = plan.sellingPlan;
      if (Object.keys(props).length) item.properties = props;

      var btn = root.querySelector('[data-add]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'adding…'; }

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
        .then(function (result) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: result } }));
          if (window._learnq && s.who === 'gift') {
            window._learnq.push(['track', 'Added Gift Subscription', {
              plan: plan.title, size: s.size, pairs: s.pairs, value: variant.price / 100
            }]);
          }
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          if (formErr) {
            formErr.textContent = (err && err.description) || 'We couldn’t add that to the cart. Please try again.';
            formErr.classList.add('on');
          }
        });
    }

    /* ----------------------------- sticky bar ----------------------------- */
    function syncSticky(priceLabel) {
      var bar = document.getElementById('fcv2-sticky');
      if (!bar) return;
      var plan = PLANS[s.plan] || {};
      var planEl = bar.querySelector('[data-sticky-plan]');
      var noteEl = bar.querySelector('[data-sticky-note]');
      var priceEl = bar.querySelector('[data-sticky-price]');
      var ctaEl = bar.querySelector('[data-sticky-cta]');
      if (planEl) planEl.textContent = (plan.title || '') + ' · ' + (s.who === 'gift' ? 'gift' : 'for me');
      if (noteEl) noteEl.textContent = s.plan === 'monthly' ? 'renews monthly · cancel anytime' : 'prepaid · never auto-renews';
      if (priceEl) priceEl.textContent = priceLabel;
      if (ctaEl) ctaEl.childNodes[0].nodeValue = s.who === 'gift' ? 'gift it ' : 'start ';
    }

    function initSticky() {
      var bar = document.getElementById('fcv2-sticky');
      var hero = document.querySelector('.fcv2-hero');
      if (!bar || !hero) return;
      document.body.classList.add('fcv2-has-sticky');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.classList.toggle('on', !entries[0].isIntersecting);
          document.body.classList.toggle('fcv2-sticky-on', !entries[0].isIntersecting);
        }, { rootMargin: '-120px 0px 0px 0px' }).observe(hero);
      }
      var cta = bar.querySelector('[data-sticky-cta]');
      if (cta) cta.addEventListener('click', function (e) {
        e.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    render();
    initSticky();
  })();

  /* ==========================================================================
     Presentational behaviour, carousel, reel, videos, FAQ.
     Kept separate so a failure here can never block add-to-cart.
     ========================================================================== */
  (function () {
    'use strict';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* carousel */
    var car = document.querySelector('[data-fcv2-car]');
    if (car) {
      var slides = [].slice.call(car.querySelectorAll('.slide'));
      var dots = document.querySelector('[data-fcv2-dots]');
      var cap = car.querySelector('[data-cap]');
      var num = car.querySelector('[data-num]');
      var i = 0, timer = null;
      var delay = parseInt(car.getAttribute('data-autoplay') || '5000', 10);

      if (slides.length > 1 && dots) {
        slides.forEach(function (_, k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Image ' + (k + 1));
          b.addEventListener('click', function () { go(k, true); });
          dots.appendChild(b);
        });
      }
      function go(k, user) {
        i = (k + slides.length) % slides.length;
        slides.forEach(function (sl, j) { sl.classList.toggle('on', j === i); });
        if (cap) cap.textContent = slides[i].getAttribute('data-caption') || '';
        if (num) num.textContent = (i + 1) + '/' + slides.length;
        if (dots) [].forEach.call(dots.children, function (d, j) { d.setAttribute('aria-current', String(j === i)); });
        if (user) restart();
      }
      function restart() {
        if (reduce || slides.length < 2 || !delay) return;
        clearInterval(timer);
        timer = setInterval(function () { go(i + 1); }, delay);
      }
      var prev = car.querySelector('.prev'), next = car.querySelector('.next');
      if (prev) prev.addEventListener('click', function () { go(i - 1, true); });
      if (next) next.addEventListener('click', function () { go(i + 1, true); });
      car.addEventListener('mouseenter', function () { clearInterval(timer); });
      car.addEventListener('mouseleave', restart);
      car.addEventListener('focusin', function () { clearInterval(timer); });
      car.addEventListener('focusout', restart);
      if (slides.length) { go(0); restart(); }
    }

    /* drag-scroll reel */
    var reel = document.querySelector('[data-fcv2-reel]');
    if (reel) {
      var down = false, moved = 0, sx = 0, sl = 0;
      reel.addEventListener('pointerdown', function (e) {
        down = true; moved = 0; sx = e.clientX; sl = reel.scrollLeft;
        reel.setPointerCapture(e.pointerId);
      });
      reel.addEventListener('pointermove', function (e) {
        if (!down) return;
        var d = e.clientX - sx;
        moved = Math.max(moved, Math.abs(d));
        reel.scrollLeft = sl - d;
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        reel.addEventListener(ev, function () { down = false; });
      });
      reel.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      reel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { reel.scrollBy({ left: 204, behavior: 'smooth' }); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { reel.scrollBy({ left: -204, behavior: 'smooth' }); e.preventDefault(); }
      });

      /* progress thumb + end-of-reel fade toggle */
      var prog = document.querySelector('[data-fcv2-reel-prog] span');
      function updateProg() {
        var max = reel.scrollWidth - reel.clientWidth;
        var atEnd = max <= 2 || reel.scrollLeft >= max - 2;
        reel.classList.toggle('at-end', atEnd);
        if (!prog) return;
        var frac = reel.scrollWidth ? reel.clientWidth / reel.scrollWidth : 1;
        var pos = max > 0 ? reel.scrollLeft / max : 0;
        var wPct = Math.max(12, Math.min(100, frac * 100));
        prog.style.width = wPct + '%';
        prog.style.marginLeft = (pos * (100 - wPct)) + '%';
      }
      reel.addEventListener('scroll', updateProg, { passive: true });
      window.addEventListener('resize', updateProg);
      updateProg();
    }

    /* unboxing: pieces fly in and assemble into the flat lay */
    var assemble = document.querySelector('[data-fcv2-assemble]');
    if (assemble && !reduce) {
      assemble.classList.add('arm'); // arm the pre-reveal offsets before it scrolls in
      var reveal = function () { assemble.classList.add('is-in'); };
      if ('IntersectionObserver' in window) {
        var ob = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { reveal(); ob.disconnect(); }
          });
        }, { threshold: 0.3 });
        ob.observe(assemble);
      } else {
        reveal();
      }
    }

    /* video tiles.
       Browsers block autoplay with sound, so hover stays a silent preview and a
       click plays with audio (a real user gesture). Only one tile sounds at a
       time, and leaving a deliberately-playing tile doesn't stop it. */
    (function () {
      var tiles = [].slice.call(document.querySelectorAll('[data-fcv2-video]'));
      if (!tiles.length) return;

      function stopAll(except) {
        tiles.forEach(function (t) {
          if (t === except) return;
          var v = t.querySelector('video');
          if (!v) return;
          v.pause(); v.muted = true; v.currentTime = 0;
          t.classList.remove('is-playing');
          setSound(t, false);
          var p = t.querySelector('.play'); if (p) p.style.display = '';
        });
      }
      function setSound(tile, on) {
        var btn = tile.querySelector('[data-fcv2-sound]');
        if (!btn) return;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
        var ico = btn.querySelector('.ico'), txt = btn.querySelector('.txt');
        if (ico) ico.textContent = on ? '\u25A0' : '\u25B6';
        if (txt) txt.textContent = on ? 'sound off' : 'sound on';
      }

      tiles.forEach(function (tile) {
        var v = tile.querySelector('video');
        if (!v) return;
        var play = tile.querySelector('.play');
        var sound = tile.querySelector('[data-fcv2-sound]');

        // silent preview on hover, only while not deliberately playing
        tile.addEventListener('mouseenter', function () {
          if (tile.classList.contains('is-playing')) return;
          v.muted = true;
          v.play().catch(function () {});
          if (play) play.style.display = 'none';
        });
        tile.addEventListener('mouseleave', function () {
          if (tile.classList.contains('is-playing')) return;
          v.pause(); v.currentTime = 0;
          if (play) play.style.display = '';
        });

        // click = watch it properly, with sound
        tile.addEventListener('click', function (e) {
          if (sound && sound.contains(e.target)) return;
          if (tile.classList.contains('is-playing')) {
            v.pause(); tile.classList.remove('is-playing'); setSound(tile, false);
            if (play) play.style.display = '';
            return;
          }
          stopAll(tile);
          tile.classList.add('is-playing');
          v.muted = false; v.volume = 1;
          setSound(tile, true);
          if (play) play.style.display = 'none';
          v.play().catch(function () {
            // if the browser still refuses audio, fall back to a silent play
            v.muted = true; setSound(tile, false); v.play().catch(function () {});
          });
        });

        // explicit mute/unmute while watching
        if (sound) sound.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!tile.classList.contains('is-playing')) {
            stopAll(tile);
            tile.classList.add('is-playing');
            if (play) play.style.display = 'none';
          }
          v.muted = !v.muted;
          setSound(tile, !v.muted);
          if (v.paused) v.play().catch(function () {});
        });

        v.addEventListener('ended', function () {
          tile.classList.remove('is-playing'); setSound(tile, false);
          if (play) play.style.display = '';
        });
      });
    })();

    /* reviews: expand a column's extra quotes */
    document.querySelectorAll('[data-fcv2-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.closest('[data-fcv2-col]');
        if (!col) return;
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        var label = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        var icon = btn.querySelector('.sock');
        btn.textContent = label;
        if (icon) btn.insertBefore(icon, btn.firstChild);
        if (!open) col.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    /* single-open FAQ */
    var faqs = [].slice.call(document.querySelectorAll('.fcv2-faq details'));
    faqs.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  })();

  /* ==========================================================================
     Motion. Progressive enhancement only: if any of this fails the page is a
     normal, fully readable page. No libraries, one IntersectionObserver,
     transforms and opacity only.
     ========================================================================== */
  (function () {
    'use strict';
    // Every section renders its own .fcv2 wrapper, so flagging only the first
    // left the reveal rule matching nothing at all.
    var roots = document.querySelectorAll('.fcv2');
    if (!roots.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    roots.forEach(function (r) { r.setAttribute('data-fcv2-motion', ''); });

    /* ---------- scroll reveal, staggered within each group ---------- */
    var GROUPS = [
      '.fcv2-unbox .shot', '.fcv2-unbox .r',
      '.fcv2-reel .m',
      '.fcv2-shark > *', '.fcv2-tiles figure',
      '.fcv2-flow .step', '.fcv2-flow .reassure',
      '.fcv2-reviews .col', '.fcv2-faq details', '.fcv2-faq .closer',
      '.fcv2-band .top', '.fcv2-year .head', '.fcv2-flow .head', '.fcv2-reviews .head', '.fcv2-faq .head',
      '.fcv2-ribbon',
      // home v2 + kids v2 (fc-pages-v2.css)
      '.av2-hero .copy', '.av2-hero .collage', '.av2-time .head', '.av2-time .m', '.av2-time .closing',
      '.hv2-shark .shot', '.hv2-shark .story', '.hv2-shark .n', '.hv2-brand .head', '.hv2-brand .belief', '.hv2-brand .line',
      '.hv2-products .head', '.hv2-products .pcard',
      '.hv2-door', '.hv2-feat .media', '.hv2-feat .r', '.hv2-feat .head', '.hv2-more .card', '.hv2-more .head',
      '.kv2-ben .head', '.kv2-ben .card', '.kv2-size .copy', '.kv2-size .card',
      '.kv2-packs .head', '.kv2-packs .fan', '.kv2-packs .card', '.kv2-packs .hack', '.kv2-vs .head', '.kv2-vs .card', '.kv2-mods .media', '.kv2-mods .copy', '.kv2-cmp .head', '.kv2-cmp .card'
    ];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);           // one-shot: no ongoing cost
        clearStagger(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    var tracked = [];
    // the stagger delay is only for the reveal; left in place it also delays every
    // hover transition (tilt, lift), which on a 60fps pointermove never gets to
    // start, so the 2nd+ card in a row looked dead. Drop it once revealed.
    function clearStagger(el) {
      var done = function () { el.style.transitionDelay = ''; };
      el.addEventListener('animationend', done, { once: true });
      setTimeout(done, 1200);
    }
    // kids colour fan: one sock, twenty colours, fans out when it scrolls in;
    // hovering a pack card lifts that pack's socks.
    document.querySelectorAll('[data-kv2-fan]').forEach(function (fan) {
      var socks = fan.querySelectorAll('.s:not(.seed)');
      fan.style.setProperty('--n', socks.length);
      // step between socks in px: spread the fan across ~88% of the box width
      var size = function () {
        var w = fan.clientWidth, n = Math.max(socks.length, 1);
        fan.style.setProperty('--step', ((w * 0.88) / n).toFixed(2) + 'px');
      };
      size();
      if ('ResizeObserver' in window) new ResizeObserver(size).observe(fan); else window.addEventListener('resize', size);
      var show = function () { fan.classList.add('is-in'); };
      if ('IntersectionObserver' in window) {
        var fo = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { show(); fo.disconnect(); } }); }, { threshold: 0.35 });
        fo.observe(fan);
      } else { show(); }
      var cards = fan.closest('section') ? fan.closest('section').querySelectorAll('.card[data-pack]') : [];
      cards.forEach(function (card) {
        var mine = fan.querySelectorAll('.s[data-pack="' + card.getAttribute('data-pack') + '"]');
        card.addEventListener('pointerenter', function () { mine.forEach(function (s) { s.classList.add('is-up'); }); });
        card.addEventListener('pointerleave', function () { mine.forEach(function (s) { s.classList.remove('is-up'); }); });
      });
    });
    GROUPS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        el.classList.add('fcv2-rv');
        el.style.transitionDelay = Math.min(i, 6) * 55 + 'ms';
        tracked.push(el);
        // anything already on screen shows immediately, never animate in
        // something the visitor is already looking at
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('is-in'); clearStagger(el); }
        else io.observe(el);
      });
    });
    // failsafe: hiding content behind an observer is only acceptable if it can
    // never get stuck. If anything is still hidden after 2.5s, just show it.
    setTimeout(function () {
      tracked.forEach(function (el) { el.classList.add('is-in'); });
    }, 2500);

    /* ---------- stats count up when they arrive ---------- */
    function countUp(el) {
      var raw = el.textContent.trim();
      var m = raw.match(/^([^\d]*)([\d,]+)(.*)$/);
      if (!m) return;
      var target = parseInt(m[2].replace(/,/g, ''), 10);
      if (!target || target < 10) return;
      var pre = m[1], post = m[3], t0 = null, dur = 1100;
      el.classList.add('counting');
      function step(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + Math.round(target * eased).toLocaleString() + post;
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var statIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        countUp(en.target);
        statIo.unobserve(en.target);
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('.fcv2-band .stats b, .fcv2-reviews .score b, .hv2-shark .n b').forEach(function (b) {
      // Only animate real tallies, something with a thousands separator or a "+".
      // A bare "2012" is the founding year and must not become "2,012".
      if (/[,+]/.test(b.textContent) && /\d{3,}/.test(b.textContent)) statIo.observe(b);
    });

    /* ---------- buy box micro-interactions ---------- */
    var lastPrice = null;
    function pulsePrice() {
      ['.fcv2-bb .cta .p', '.fcv2-sticky [data-sticky-price]'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        el.classList.remove('rolled');
        void el.offsetWidth;                // restart the animation
        el.classList.add('rolled');
      });
    }
    // the buy box re-renders on every choice, so watch rather than bind
    var bb = document.querySelector('[data-fcv2-buybox]');
    if (bb) {
      new MutationObserver(function () {
        var p = document.querySelector('.fcv2-bb .cta .p');
        if (!p) return;
        var now = p.textContent;
        if (lastPrice !== null && now !== lastPrice) pulsePrice();
        lastPrice = now;
      }).observe(bb, { childList: true, subtree: true });

      bb.addEventListener('click', function (e) {
        var opt = e.target.closest('.opt');
        if (!opt) return;
        requestAnimationFrame(function () {
          var again = bb.querySelector('.opt[aria-pressed="true"][data-k="' + opt.dataset.k + '"]');
          if (!again) return;
          again.classList.add('just-picked');
          setTimeout(function () { again.classList.remove('just-picked'); }, 340);
        });
      });
    }

  
  /* ---------- extra motion: tilt, parallax, progress, sheen ---------- */
  (function () {
    if (reduce) return;

    // 1. subtle cursor tilt on the retro cards (pointer devices only)
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.querySelectorAll('.fcv2-reel .m .ph, .fcv2-tiles figure, .hv2-door, .kv2-packs .card, .kv2-ben .card, .hv2-more .card, .hv2-brand .belief, .hv2-products .pcard, .fcv2-reviews .card, .fcv2-stcopy, .hv2-shark .n, .kv2-size .card, .kv2-cmp .card, .kv2-vs .card, .fcv2-faq .closer').forEach(function (card) {
        var raf = null;
        card.style.transformStyle = 'preserve-3d';
        card.addEventListener('pointerenter', function () { card.style.transitionDelay = ''; });
        card.addEventListener('pointermove', function (e) {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var b = card.getBoundingClientRect();
            var rx = ((e.clientY - b.top) / b.height - 0.5) * -5;
            var ry = ((e.clientX - b.left) / b.width - 0.5) * 5;
            card.style.transform = 'perspective(700px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translate(-2px,-2px)';
            // the hard shadow slides away from the cursor, as if the cursor were the light
            card.style.boxShadow = (6 - ry * 1.1).toFixed(1) + 'px ' + (6 + rx * 1.1).toFixed(1) + 'px 0 0 #181818';
          });
        });
        card.addEventListener('pointerleave', function () { card.style.transform = ''; card.style.boxShadow = ''; });
      });
    }

    // 2. the unboxing photo drifts a little as it passes
    var shot = document.querySelector('.fcv2-unbox .shot:not(.assemble) img');
    if (shot) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var b = shot.getBoundingClientRect();
          if (b.bottom < 0 || b.top > window.innerHeight) return;
          var p = (b.top + b.height / 2 - window.innerHeight / 2) / window.innerHeight;
          shot.style.transform = 'scale(1.06) translateY(' + (p * -14).toFixed(1) + 'px)';
        });
      }, { passive: true });
    }

    // 3. reading-progress hairline
    var bar = document.createElement('div');
    bar.className = 'fcv2-progress';
    document.body.appendChild(bar);
    var pTick = false;
    window.addEventListener('scroll', function () {
      if (pTick) return;
      pTick = true;
      requestAnimationFrame(function () {
        pTick = false;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0) + ')';
      });
    }, { passive: true });
  })();

  /* ---------- confetti when something lands in the cart ---------- */
    var COLOURS = ['#F8D86E', '#4294E1', '#FF69B4', '#22c55e', '#181818'];
    document.addEventListener('ajaxProduct:added', function () {
      var wrap = document.createElement('div');
      wrap.className = 'fcv2-confetti';
      for (var i = 0; i < 26; i++) {
        var b = document.createElement('i');
        b.style.left = (18 + Math.random() * 64) + 'vw';
        b.style.top = (28 + Math.random() * 18) + 'vh';
        b.style.background = COLOURS[i % COLOURS.length];
        b.style.setProperty('--x', (Math.random() * 300 - 150) + 'px');
        b.style.setProperty('--y', (40 + Math.random() * 45) + 'vh');
        b.style.setProperty('--r', (Math.random() * 900 - 450) + 'deg');
        b.style.setProperty('--d', (1100 + Math.random() * 700) + 'ms');
        b.style.animationDelay = (Math.random() * 120) + 'ms';
        wrap.appendChild(b);
      }
      document.body.appendChild(wrap);
      setTimeout(function () { wrap.remove(); }, 2200);
    });
  })();

}
